import axios from "axios";
import { config } from "./ConfigService";

class NotesService {
  getNote(userNoteId) {
    return axios.get(`${config.API_URL}/users/userNotes/${userNoteId}`);
  }

  // userId is the id of the user to whom the notes belongs
  findNotes(userId) {
    return axios.get(`${config.API_URL}/users/userNotesByUserId/${userId}`);
  }

  // userId is the id of the user to whom the note belongs
  saveNote(userId, noteText) {
    return axios.post(`${config.API_URL}/users/userNotes`, {
      userInfoId: userId,
      noteText: noteText,
    });
  }

  updateNote(userNoteId, updatedNoteText) {
    return axios.put(`${config.API_URL}/users/userNotes/${userNoteId}`, {
      noteText: updatedNoteText,
    });
  }
}

export default new NotesService();
